export default window._cmsContent['whd/home']